<template>
  <div class="advertising-modal">
    <PicAdvertising ref="picAdvertisingRef" @readAdvertising="readAdvertising" />
    <PageAdvertising ref="pageAdvertisingRef" @readAdvertising="readAdvertising" />
  </div>
</template>

<script setup lang="ts">
import { useAdvertisingStore } from '@/store/advertising'
import { storeToRefs } from 'pinia'
import { nextTick, ref, watch } from 'vue'
import PicAdvertising from './_components/PicAdvertising.vue'
import PageAdvertising from './_components/PageAdvertising.vue'
import { getAdvertisingClickApi } from '@/api/common'
const { curAdvertising } = storeToRefs(useAdvertisingStore())

const picAdvertisingRef = ref<typeof PicAdvertising>()
const pageAdvertisingRef = ref<typeof PageAdvertising>()

watch(
  curAdvertising,
  (newVal) => {
    nextTick(() => {
      if (newVal?.type === '2' && picAdvertisingRef.value) {
        picAdvertisingRef.value.open = true
      } else if (newVal?.type === '1' && pageAdvertisingRef.value) {
        pageAdvertisingRef.value.open = true
      }
    })
  },
  { immediate: true },
)

const readAdvertising = async () => {
  await getAdvertisingClickApi({
    popupads_id: curAdvertising.value.id,
    type: '2',
  })
}
</script>

<style lang="less" scoped>
:global(.advertising-modal-pic .ant-modal-content) {
  padding: 0;
}
</style>
